import React, { FC } from 'react'
import { Button, Icon, Overlay } from '@wmgtech/legato'

import './TableRowActions.scss'

const TableRowActions: FC = ({ children }) => (
  <Overlay
    placement="bottom-end"
    showFang={false}
    className="table-row-actions__overlay"
    trigger={
      <Button
        className="table-row-actions__btn"
        colorType="secondary-white"
        containerStyle="solid"
        icon={<Icon prefix="fas" name="ellipsis" />}
        size="sm"
      />
    }
  >
    <div className="table-row-actions">{children}</div>
  </Overlay>
)

export default TableRowActions
